import { useCallback } from 'react'

const DOCS_BASE_URL = 'https://docs.structurizr.com'

interface DocOption {
  label: string
  value: string
  indent?: number
}

const DOC_OPTIONS: DocOption[] = [
  { label: 'DSL documentation', value: '/dsl' },
  { label: 'DSL tutorial', value: '/dsl/tutorial' },
  { label: 'DSL cookbook', value: '/dsl/cookbook' },
  { label: 'Basics', value: '/dsl/basics' },
  { label: 'Identifiers', value: '/dsl/identifiers' },
  { label: 'Implied relationships', value: '/dsl/implied-relationships' },
  { label: 'Expressions', value: '/dsl/expressions' },
  { label: 'DSL language reference', value: '/dsl/language' },
  { label: 'workspace', value: '/dsl/language#workspace', indent: 1 },
  { label: 'model', value: '/dsl/language#model', indent: 2 },
  { label: 'group', value: '/dsl/language#group', indent: 2 },
  { label: 'person', value: '/dsl/language#person', indent: 2 },
  { label: 'softwareSystem', value: '/dsl/language#softwaresystem', indent: 2 },
  { label: 'container', value: '/dsl/language#container', indent: 3 },
  { label: 'component', value: '/dsl/language#component', indent: 4 },
  { label: 'deploymentEnvironment', value: '/dsl/language#deploymentenvironment', indent: 2 },
  { label: 'deploymentNode', value: '/dsl/language#deploymentnode', indent: 2 },
  { label: 'infrastructureNode', value: '/dsl/language#infrastructurenode', indent: 2 },
  { label: 'softwareSystemInstance', value: '/dsl/language#softwaresysteminstance', indent: 2 },
  { label: 'containerInstance', value: '/dsl/language#containerinstance', indent: 2 },
  { label: 'element', value: '/dsl/language#element', indent: 2 },
  { label: '-> (relationship)', value: '/dsl/language#relationship', indent: 2 },
  { label: 'views', value: '/dsl/language#views', indent: 2 },
  { label: 'systemLandscape', value: '/dsl/language#systemlandscape-view', indent: 3 },
  { label: 'systemContext', value: '/dsl/language#systemcontext-view', indent: 3 },
  { label: 'container (view)', value: '/dsl/language#container-view', indent: 3 },
  { label: 'component (view)', value: '/dsl/language#component-view', indent: 3 },
  { label: 'filtered', value: '/dsl/language#filtered-view', indent: 3 },
  { label: 'dynamic', value: '/dsl/language#dynamic-view', indent: 3 },
  { label: 'deployment', value: '/dsl/language#deployment-view', indent: 3 },
  { label: 'custom', value: '/dsl/language#custom-view', indent: 3 },
  { label: 'image', value: '/dsl/language#image-view', indent: 3 },
  { label: 'styles', value: '/dsl/language#styles', indent: 3 },
  { label: 'element (style)', value: '/dsl/language#element-style', indent: 4 },
  { label: 'relationship (style)', value: '/dsl/language#relationship-style', indent: 4 },
  { label: 'themes', value: '/dsl/language#themes', indent: 3 },
  { label: 'branding', value: '/dsl/language#branding', indent: 3 },
  { label: 'terminology', value: '/dsl/language#terminology', indent: 3 },
  { label: 'configuration', value: '/dsl/language#configuration', indent: 2 },
  { label: 'visibility', value: '/dsl/language#visibility', indent: 3 },
  { label: 'scope', value: '/dsl/language#scope', indent: 3 },
  { label: 'users', value: '/dsl/language#users', indent: 2 },
]

function getIndentPrefix(indent?: number): string {
  if (!indent) return ''
  return '\u00A0'.repeat(indent * 2) + '- '
}

export default function DslDocDropdown() {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    if (value) {
      window.open(`${DOCS_BASE_URL}${value}`, '_blank', 'noopener,noreferrer')
      // Reset to first option after opening
      e.target.value = ''
    }
  }, [])

  return (
    <select
      onChange={handleChange}
      defaultValue=""
      className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg bg-white hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 cursor-pointer"
      title="Open DSL documentation"
    >
      <option value="" disabled>
        DSL Reference
      </option>
      {DOC_OPTIONS.map((option, index) => (
        <option key={index} value={option.value}>
          {getIndentPrefix(option.indent)}{option.label}
        </option>
      ))}
    </select>
  )
}
